<template>
  <div class="acceptance-form p-4">
    <p><b>Next Steps</b></p>

    <div class="form-group">
      <label for="acceptance">
        Please provide notes to explain your reason for rejection (if applicable)
      </label>
      <textarea name="acceptance" id="acceptance" rows="5" class="form-control" v-model="text" @input="handleInput" :class="{ 'has-error': formError }"></textarea>
      <div class="buttons mt-3 text-end">
        <button @click="reject" class="btn btn-danger">Reject</button>
        &nbsp;
        <button @click="accept" class="btn btn-success">Accept Quote</button>
      </div>
    </div>

  </div>
</template>

<script>
import {EventBus} from '@/event-bus.js';

export default {
  name: "acceptance-form",
  props: [
    'quote',
    'adminPortalData',
  ],
  data() {
    return {
      text: '',
      formError: ''
    }
  },
  methods: {
    handleInput(event) {
      this.formError = false;
    },

    accept() {
      // Awful way of handling this
      if (this.quote.scheme === 'salsac') {
        this.$router.push({ name: 'Salary Sacrifice Personal Details', params: { quoteId: this.quote.quoteID } });
        return;

      } else if (this.quote.scheme === 'ecoamaps') {
        this.$router.push({ name: 'ECO / AMAPS Personal Details', params: { quoteId: this.quote.quoteID } });
        return;

      } else if (this.quote.scheme === 'bch') {
        this.$router.push({ name: 'Business Contract Hire Personal Details', params: { quoteId: this.quote.quoteID } });
        return;
      }

      this.$notify({
        group: 'notify',
        type: 'error',
        title: 'Error',
        text: "There has been an error accepting this vehicle - please contact Origo Support"
      });
    },

    async reject() {
      if (this.text === '') {
        this.formError = true;
        this.$notify({
          group: 'notify',
          type: 'error',
          text: "Please enter a reason for rejecting this vehicle",
        });
        return;
      }

      EventBus.$emit('loadingTitle', 'Updating Quotes');
      EventBus.$emit('loading', true);

      try {
        const response = await this.$http.post('/api/replacement-reject', {
          quoteId: this.quote.quoteID,
          reason: this.text
        });

        if (response.data.status !== 200) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: "There has been an error removing this quote - please try again"
          });
        } else {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: 'Success',
            text: "Quote removed"
          });
          this.text = '';
          EventBus.$emit('rejected-replacement', this.quote.quoteID)
        }

        EventBus.$emit('loading', false);

      } catch(err) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: 'Error',
          text: "There has been an error removing this quote - please try again"
        });

        EventBus.$emit('loading', false);
      }
    }
  },
}
</script>

<style scoped lang="scss">
  .acceptance-form {
    background-color: #F6F9FA;

    label {
      font-size: 12px;
    }
  }
</style>
